/**
 * @private
 * Push somethig in dataLayer
 * @param obj object to push
 */
const dataLayerPush = (obj) => {
  if (!obj) return;

  window.dataLayer = window.dataLayer ?? [];

  obj = cleanupNull(obj);

  window.dataLayer.push(obj);
};

/**
 * @private
 * cleanup inner props
 * @param {object} obj
 */
const cleanupNull = (obj) => {
  if (obj === null) return undefined;

  if (typeof obj === 'string') return obj;

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (Array.isArray(obj[key])) {
        for (let index = 0; index < obj[key].length; index++) {
          obj[key][index] = cleanupNull(obj[key][index]);
        }
      } else {
        obj[key] = cleanupNull(obj[key]);
      }
    }
  }

  return obj;
};

/**
 * Push new Core dataLayer info
 * @param data the meta data
 */
export const addCoreDataLayer = (data) => {
  dataLayerPush({
    'event': 'dataLayer-initialized',
    ...data,
  });
};

/**
 * Track generic event
 * @param {string} eventName event name
 * @param {any} data event data
 */
export const trackEvent = (eventName, data = {}) => {
  dataLayerPush({
    'event': eventName,
    ...data
  });
};

/**
 * track block impression
 * @param {string} bucketName
 * @param {string} blockType
 * @param {{
 * id: string,
 * name: string,
 * creative: string,
 * position: string,
 * }[]} promotions
 */
export const trackBlockImpression = (bucketName, blockType, promotions) => {
  const impressionData = {
    bucketName,
    blockType,
    'ecommerce': promotions?.length ? {
      'promoView': {
        promotions,
      },
    } : undefined,
  };

  trackEvent('block-impression', impressionData);
};


/**
 * track block click
 * @param {string} bucketName
 * @param {string} blockType
 * @param {object} data
 * @param {{
  * id: string,
  * name: string,
  * creative: string,
  * position: string,
  * }} promotion
  */
export const trackBlockClick = (bucketName, blockType, layoutName, blockLayout, blockStyle, data, promotion) => {
  const clickData = {
    bucketName,
    blockType,
    layoutName,
    blockLayout,
    blockStyle,
    ...data,
    'ecommerce': promotion ? {
      'promoClick': {
        promotions: [promotion],
      },
    } : undefined,
  };

  trackEvent('block-click', clickData);
};

/**
 * Track MatchHub click event
 * @param {{
 * clickType: string,
 * clickItem: string,
 * match: string,
 * matchState: string,
 * clubName: string,
 * playerName: string,
 * competition: string,
 * cardType: string,
 * optaEventType: string,
 * toggle: string
 * }} clickData
 */
export const trackMatchHubClick = (clickData) => {
  trackEvent('match-hub-click', clickData);
};

/**
 * Track Match interaction event
 * @param {{
  * clickType: string,
  * clickItem: string,
  * clickPosition: string,
  * matchState: string,
  * match: string,
  * competition: string,
  * travelType: string
  * }} clickData
  */
export const trackMatchInteraction = (clickData) => {
  trackEvent('match-interaction', clickData);
};

/**
 * Track Match interaction event
 * @param {{
  * module_type: string,
  * location: string,
  * match: string
  * }} clickData
  */
export const trackModuleImpression = (clickData) => {
  trackEvent('module_impression', clickData);
};

/**
 * Track generic CTA click event
 * @param {{
  * click_type: string,
  * cta_label: string,
  * click_url: string
  * }} clickData
  */
export const trackCtaClick = (clickData) => {
  trackEvent('cta_click', clickData);
};

/**
 * Track Module click event
 * @param {{
  * module_type: string,
  * match_id: string,
  * match: string,
  * location: string,
  * platform: string,
  * domain: string
  * }} clickData
  */
export const trackModuleClick = (clickData) => {
  trackEvent('module_click', clickData);
};


/**
 * Track Week Selector event
 * @param {{
  * selectorLocation: 'top' | 'bottom',
  * direction: 'forward' | 'back',
  * selection: string
  * }} clickData
  */
export const trackWeekSelector = (clickData) => {
  trackEvent('week-selector-click', clickData);
};

/**
 * Track Filter interaction event
 * @param {{
  * statsCategory: string,
  * filterType: string,
  * clickItem: string
  * }} clickData
  */
export const trackFilterClick = (clickData) => {
  trackEvent('filter-click', clickData);
};

/**
 * Track FeaturedMatch click event
 * @param {{
* clickType: string,
* clickItem: string,
* match: string,
* matchState: string,
* playerName: string,
* competition: string,
* toggle: string
* }} clickData
*/
export const trackFeaturedMatchClick = (clickData) => {
 trackEvent('featured-match-click', clickData);
};

/**
 * Track HorizontalScoreboardMatch click event
 * @param {{
* clickType: string,
* clickItem: string,
* match: string,
* matchState: string,
* competition: string,
* clickPosition: string,
* }} clickData
*/
export const trackHorizontalScoreboardMatch = (clickData) => {
 trackEvent('horizontal-scoreboard-match-click', clickData);
};

/**
 * Track user successful login event
 * @param {{
* userId: string,
* method: string,
* }} eventData
*/
export const trackUserLogin = (eventData) => {
  trackEvent('successful-login-freemium', eventData);
};


/**
 * Track user login freemium login wall event
*/
export const trackUserFreemiumLoginWall = (eventData) => {
  trackEvent('freemium-login-wall', eventData);
};

export const trackUserFreemiumLoginWallViewed = (eventData) => {
  trackEvent('freemium-login-wall_viewed', eventData);
};

export const trackUserFreemiumLoginWallCtaClicked = (eventData) => {
  trackEvent('freemium-cta-click', eventData);
};

export const trackUserFreemiumSuccessfulSignup = (eventData) => {
  trackEvent('successful-signup', eventData);
};

export const trackUserFreemiumSuccessfulLogin = (eventData) => {
  trackEvent('successful-login-freemium', eventData);
};

export const trackUserLogged = (userId) => {
  // const dataLayerInitialized = window.dataLayer.find((e) => e.event == 'dataLayer-initialized');

  // if (dataLayerInitialized) {
  //   dataLayerPush({
  //     ...dataLayerInitialized,
  //     'userId': userId,
  //   });
  // }
};
